import { FilterType, WhereOperator, } from "@biggeo/bg-server-lib/studio";
import isEqual from "lodash/isEqual";
import { match } from "ts-pattern";
export var GeospatialSelectionType;
(function (GeospatialSelectionType) {
    GeospatialSelectionType["viewport"] = "viewport";
    GeospatialSelectionType["multipolygon"] = "multipolygon";
})(GeospatialSelectionType || (GeospatialSelectionType = {}));
export const matchOperatorsByType = {
    [FilterType.BooleanType]: [
        WhereOperator.equals,
        WhereOperator.isEmpty,
        WhereOperator.isNotEmpty,
    ],
    [FilterType.StringType]: [
        WhereOperator.equals,
        WhereOperator.contains,
        WhereOperator.startsWith,
        WhereOperator.endsWith,
        WhereOperator.isEmpty,
        WhereOperator.isNotEmpty,
    ],
    [FilterType.NumberType]: [
        WhereOperator.eq,
        WhereOperator.neq,
        WhereOperator.gt,
        WhereOperator.gte,
        WhereOperator.lt,
        WhereOperator.lte,
        WhereOperator.isEmpty,
        WhereOperator.isNotEmpty,
    ],
    [FilterType.DateType]: [
        WhereOperator.eq,
        WhereOperator.neq,
        WhereOperator.gt,
        WhereOperator.gte,
        WhereOperator.lt,
        WhereOperator.lte,
        WhereOperator.isEmpty,
        WhereOperator.isNotEmpty,
    ],
};
export const getOperatorsByType = (type) => matchOperatorsByType[type];
export const getWhereOperatorLabel = ({ operator, verbose = false, }) => match(operator)
    .with(WhereOperator.eq, () => (verbose ? "Equals" : "="))
    .with(WhereOperator.neq, () => (verbose ? "Not Equals" : "!="))
    .with(WhereOperator.gt, () => (verbose ? "Greater Than" : ">"))
    .with(WhereOperator.gte, () => verbose ? "Greater Than Or Equals" : ">=")
    .with(WhereOperator.lt, () => (verbose ? "Less Than" : "<"))
    .with(WhereOperator.lte, () => (verbose ? "Less Than Or Equals" : "<="))
    .with(WhereOperator.isEmpty, () => "Is Empty")
    .with(WhereOperator.isNotEmpty, () => "Is Not Empty")
    .with(WhereOperator.startsWith, () => "Starts With")
    .with(WhereOperator.endsWith, () => "Ends With")
    .with(WhereOperator.equals, () => "Equals")
    .otherwise(() => "Contains");
export const getFilterValueString = (type, data) => {
    return match(type)
        .with(FilterType.BooleanType, () => data.booleanData ? data.booleanData.toString() : undefined)
        .with(FilterType.DateType, () => data.dateData ? data.dateData.toString() : undefined)
        .with(FilterType.NumberType, () => data.numberData ? data.numberData.toString() : undefined)
        .with(FilterType.StringType, () => data.stringData ? data.stringData.toString() : undefined)
        .exhaustive();
};
export const getFilterData = (type, value) => {
    return {
        ...(isEqual(type, FilterType.BooleanType) && {
            booleanData: value ? value === "true" : null,
        }),
        ...(isEqual(type, FilterType.DateType) && {
            dateData: value ? new Date(value) : null,
        }),
        ...(isEqual(type, FilterType.NumberType) && {
            numberData: value ? Number.parseInt(value) : null,
        }),
        ...(isEqual(type, FilterType.StringType) && {
            stringData: value ? value : null,
        }),
    };
};
//# sourceMappingURL=geo-helpers.js.map